//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wcs from '@/scripts/libs/wcs'

export default {
  name: 'RbNoResults',
  computed: {
    linkSunglasses() {
      return wcs.getEndPoint('sunglassesURL')
    },
    linkOptics() {
      return wcs.getEndPoint('eyeglassesURL')
    },
    buttons() {
      return [
        {
          url: this.linkSunglasses,
          label: this.$t('plp.view_all_sunglasses'),
          track: 'Plp_NoResults_ViewAllSunglasses',
        },
        {
          url: this.linkOptics,
          label: this.$t('plp.view_all_eyeglasses'),
          track: 'Plp_NoResults_ViewAllEyeglasses',
        },
      ]
    },
  },
}
